import { showAlert } from "features/modal/modalSlice";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import { signInUsingCode } from "services/authService";

const Gateway = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search.replace(/&amp;/gi, "&"));
  const dispatch = useDispatch();
  const code = params.get("code");
  const type = params.get("type");
  const purpose = params.get("purpose");
  const name = params.get("name");
  const requestId = params.get("requestId");
  const requireCompleteAction = params.get("requireCompleteAction");
  const error = params.get("error");
  const message = params.get("message");
  const errorType = params.get("errorType");
  const leaveDate = params.get("leaveDate");
  const reSignupDate = params.get("reSignupDate");
  useEffect(() => {
    if (error === "true") {
      dispatch(showAlert({ message }));

      navigate && navigate(routes.home, { replace: true });
    }

    // 본인인증 완료
    if (type === "SELF_VERIFICATION_COMPLETED") {
      const isSimpleLoginPopup =
        sessionStorage.getItem("is_simple_login_popup") === "true";
      if (isSimpleLoginPopup) {
        sessionStorage.removeItem("is_simple_login_popup");
      }

      // 회원가입
      if (purpose === "SIGNUP") {
        if (requireCompleteAction === "true") {
          // 본인인증 후 가입 시작
          // 팝업 플로우인 경우 메인 창에서 가입 진행되도록 신호 전달 후 팝업 닫기
          if (isSimpleLoginPopup) {
            const payload = { type: "signup_required", requestId };
            if (window.opener) {
              window.opener.postMessage(payload, window.location.origin);
            } else {
              localStorage.setItem("simple_signup_requestId", requestId);
            }
            window.close();
          } else {
            navigate(routes.authSignUpAcceptTerms, {
              state: { requestId },
              replace: true,
            });
          }
        } else {
          // 가입 완료
          if (message) {
            dispatch(showAlert({ message }));
          }
          signInUsingCode(code, navigate, "", "", isSimpleLoginPopup);
        }
      }
      // 휴대폰번호 변경
      else if (purpose === "UPDATE_PHONENUMBER") {
        signInUsingCode(code, navigate, routes.mypageChangeInfo); // 변경 후 내정보 변경 페이지로 이동
        dispatch(showAlert({ message }));
      }
      // 결제비밀번호 변경
      else if (purpose === "UPDATE_SECURE_PASSWORD") {
        if (requireCompleteAction === "true") {
          navigate(routes.authSignUpRegisterPin, {
            replace: true,
            state: { purpose, requestId },
          });
        } else {
          signInUsingCode(code, navigate);
        }
      }
    }
    // Oauth Login
    else if (type === "OAUTH_COMPLETED") {
      if (purpose === "SIGNIN" || purpose === "SIGNUP") {
        // iOS Apple 리다이렉트 플로우는 메인 창에서 실행되므로 shouldPostMessage=false
        const isAppleIOSRedirect =
          sessionStorage.getItem("apple_ios_redirect") === "true";
        sessionStorage.removeItem("apple_ios_redirect");
        signInUsingCode(code, navigate, "", "", !isAppleIOSRedirect);
      }
    }
  }, []);

  return <div></div>;
};

export default Gateway;
